<div [hidden]="ifNotRoot" class="scrollable-div">
  <div class="container">
    <div class="_Hejdi listing_wrap">
      <div
        class="card _listing"
        (click)="goToDetails(item.id)"
        style="width: 18rem; cursor: pointer;"
        *ngFor="let item of list"
      >
        <div
          [ngStyle]="{ 'background-image': 'url(' + item.images[0] + ')' }"
          class="card-img-top card-photo"
        ></div>
        <div class="card-body">
          <h5 class="card-title">{{ item.name ? item.name : 'No Title' }}</h5>
          <p class="card-text price">${{ item.rentalPrice }} /day</p>
          <p class="card-text location">
            {{ item.location ? item.location : 'No Location' }}
          </p>
          <span class="star_rating" style="width:50px;"></span>
        </div>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
